import { createAction } from 'redux-actions'
import * as actionTypes from './constants'

export const fetchRules = createAction(actionTypes.FETCH_RULES)
export const fetchRulesPending = createAction(actionTypes.FETCH_RULES_PENDING)
export const fetchRulesCancelled = createAction(actionTypes.FETCH_RULES_CANCELLED)
export const fetchRulesFailed = createAction(actionTypes.FETCH_RULES_FAILED)
export const fetchRulesSuccess = createAction(actionTypes.FETCH_RULES_SUCCESS)

export const fetchRulesByIds = createAction(actionTypes.FETCH_RULES_BY_IDS)
export const fetchRulesByIdsPending = createAction(actionTypes.FETCH_RULES_BY_IDS_PENDING)
export const fetchRulesByIdsCancelled = createAction(actionTypes.FETCH_RULES_BY_IDS_CANCELLED)
export const fetchRulesByIdsFailed = createAction(actionTypes.FETCH_RULES_BY_IDS_FAILED)
export const fetchRulesByIdsSuccess = createAction(actionTypes.FETCH_RULES_BY_IDS_SUCCESS)

export const fetchRoundRobinByKey = createAction(actionTypes.FETCH_ROUND_ROBIN_BY_KEY)
export const fetchRoundRobinByKeyPending = createAction(actionTypes.FETCH_ROUND_ROBIN_BY_KEY_PENDING)
export const fetchRoundRobinByKeyCancelled = createAction(actionTypes.FETCH_ROUND_ROBIN_BY_KEY_CANCELLED)
export const fetchRoundRobinByKeyFailed = createAction(actionTypes.FETCH_ROUND_ROBIN_BY_KEY_FAILED)
export const fetchRoundRobinByKeySuccess = createAction(actionTypes.FETCH_ROUND_ROBIN_BY_KEY_SUCCESS)

export function editRule(rule) {
  return {
    type: actionTypes.EDIT_RULE,
    rule,
  }
}

export function resetActiveRule() {
  return {
    type: actionTypes.RESET_ACTIVE_RULE,
  }
}

export function resetActiveRuleAction() {
  return {
    type: actionTypes.RESET_ACTIVE_RULE_ACTION
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/rules/actions.js